// src/ui/ClipEditor.js
// Isolated mini piano-roll for editing a single ClipDefinition's notes.

import { clipLibrary, ClipLibrary } from '../clips/ClipLibrary.js';

export class ClipEditor {
  constructor(rootEl) {
    this.root = rootEl;
    this.clipId = null;
    this._render();
  }

  open(clipId) {
    this.clipId = clipId;
    this._render();
  }

  close() {
    this.clipId = null;
    this.root.innerHTML = '';
  }

  _render() {
    if (!this.clipId) {
      this.root.innerHTML = '<p style="color:var(--text-2);padding:12px">Select a clip to edit</p>';
      return;
    }
    const def = clipLibrary.getClip(this.clipId);
    if (!def) {
      this.root.innerHTML = '<p style="color:var(--danger)">Clip not found</p>';
      return;
    }
    this.root.innerHTML = `
      <div class="clip-editor-header">
        <input class="clip-editor-name" value="${def.name.replace(/"/g, '&quot;').replace(/</g, '&lt;')}" />
        <button class="clip-editor-close">✕</button>
      </div>
      <div class="clip-editor-canvas-container">
        <canvas class="clip-editor-canvas"></canvas>
      </div>
      <div class="clip-editor-notes">
        <p>${def.notes.length} note(s)</p>
      </div>
    `;
    this.root.querySelector('.clip-editor-close').onclick = () => this.close();
    const nameInput = this.root.querySelector('.clip-editor-name');
    nameInput.onchange = () => clipLibrary.renameClip(this.clipId, nameInput.value);
    // Draw mini piano roll
    const canvas = this.root.querySelector('.clip-editor-canvas');
    const ctx = canvas.getContext('2d');
    const parentRect = this.root.getBoundingClientRect();
    canvas.width = parentRect.width - 24;
    canvas.height = 200;
    const dur = ClipLibrary.getDuration(def.notes);
    const zoomX = (canvas.width - 20) / Math.max(dur, 0.1);
    const noteH = 18;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#0f0f15';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    for (const n of def.notes) {
      const x = 10 + n.time * zoomX;
      const y = canvas.height - 30 - (n.pitch - 48) * noteH;
      ctx.fillStyle = '#5fa86a';
      ctx.fillRect(x, y, Math.max(2, n.duration * zoomX), noteH - 1);
    }
  }
}
